module.exports = require('./ZEventsApiEventGroups')
